var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 35.6664C21.1893 35.6692 23.3574 35.2394 25.3798 34.4016C27.4023 33.5639 29.2393 32.3347 30.7852 30.7847C32.3352 29.2388 33.5643 27.4018 34.4021 25.3794C35.2399 23.3569 35.6697 21.1888 35.6668 18.9997C35.6696 16.8106 35.2398 14.6425 34.402 12.62C33.5643 10.5976 32.3351 8.76061 30.7852 7.21469C29.2393 5.66471 27.4023 4.43552 25.3798 3.59776C23.3574 2.76 21.1893 2.33019 19.0002 2.33302C16.8111 2.33023 14.643 2.76007 12.6205 3.59782C10.5981 4.43558 8.7611 5.66475 7.21518 7.21469C5.66524 8.76061 4.43607 10.5976 3.59831 12.62C2.76055 14.6425 2.33072 16.8106 2.33351 18.9997C2.33067 21.1888 2.76049 23.3569 3.59825 25.3794C4.43601 27.4018 5.6652 29.2388 7.21518 30.7847C8.7611 32.3346 10.5981 33.5638 12.6205 34.4016C14.643 35.2393 16.8111 35.6691 19.0002 35.6664Z",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 19L17.3335 24L27.3335 14",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnchecked);
export default __webpack_public_path__ + "static/media/icon-unchecked.358858f0092276ffc617e081697b188a.svg";
export { ForwardRef as ReactComponent };